import React from "react";
import { ButtonIcon } from "@loanbossinc/component-library";
import "./collapsibleFilterStyles.css";

const CollapsibleFilter = ({ name = "", optionCount = 0, toggleDropdownFilterVisibility: handleToggleDropdownClicked = () => { } }) => (
  <div className="dl-scrn-filter-panel-collapsible-filter-wrapper">
    <div className="dl-scrn-filter-panel-collapsible-filter-header-wrapper">
      <div>{name}</div>
      <div className="dl-scrn-filter-panel-collapsible-filter-wrapper-count-arrow-wrapper">
        <div className="collapsible-filter-count-text">{optionCount}</div>
        <ButtonIcon
          onClick={handleToggleDropdownClicked}
          iconName="expand_more"
        />
      </div>
    </div>
  </div>
);

export default CollapsibleFilter;
